import { useMemo } from 'react';

import { useTeamStore } from './useTeamStore';

import { POSITIONS_LABELS } from '@/utils';
import { fieldPlayersF5 } from '@/utils/team';

export const useNormalizeInitialF5 = () => {
  const { state } = useTeamStore();

  const normalizeInitialF5 = useMemo(() => {
    if (state.filtersApplied?.positionF5)
      return state.filtersApplied.positionF5;

    if (state.selectedPosition === POSITIONS_LABELS.all_field_players)
      return fieldPlayersF5;

    if (state.selectedPosition === POSITIONS_LABELS.abbreviation.ARQ)
      return [POSITIONS_LABELS.abbreviation.ARQ];

    if (state.selectedPosition) {
      return [state.selectedPosition];
    }

    return null;
  }, [state?.filtersApplied?.positionF5, state.selectedPosition]);

  return { normalizeInitialF5 };
};
